import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Form,
  notification,
  Radio,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Collapse,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import {
  CONFIGURATION_CONVERTER,
  CONFIGURATION_EMISSION_FACTOR,
} from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../Common/APIConstants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);



// const EmissionFactorPopupContent = ({  onClose,
//   isAdd, 
//   form,
//   selectedRow,
//   isUpdate,
//   refetch,
//   setRefetch }) => {
//   const [data, setData] = useState([]);
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const location = useLocation();

//   const handleClear = () => {
//     form.resetFields();
//   };

//   const handleNotification = (msg) => {
//     notification.open({ message: `${msg}` });
//   };
//   const formatCreatedOn = (data) => {
//     console.log(data)
//     return {
//       ...data,
//       // createdOn: dayjs(data.createdOn).format("YYYY-MM-DD HH:mm:ss"),
//       createdOn: dayjs(data.createdOn),
//     };
//   };
//  useEffect(() => {
//   console.log(selectedRow)
//   const formData = formatCreatedOn(selectedRow? selectedRow:{})
//   console.log(formData)
//   console.log(isUpdate)
//   console.log(isAdd)
//     if (isAdd && !selectedRow ) {
//       form.resetFields();
//     } 
//     if (isUpdate && selectedRow) {
//       form.setFieldsValue(formData);
//     } else {
//       form.resetFields();
//     }
//   }, [isAdd, isUpdate, selectedRow, form]);

//   const handleAddFormChange = (changedValues, allValues) => {
//     setData({
//       ...allValues,
//       createdOn: allValues.createdOn ? allValues.createdOn.toISOString() : null, // Format DateTime
//       // createdOn: allValues.createdOn ? allValues.createdOn.format("YYYY-MM-DD HH:mm:ss") : null, // Format DateTime
//     });
//     console.log(allValues);
//   };

//   const handleAddFormSubmit = async () => {
//     try {
//       const url = APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
//       // console.log(url);
//       console.log(data);

//       const response = await makeRequest({
//         type: "POST",
//         url: url,
//         body: data,
//       });
//       console.log(response);
//       // const url = isUpdate ? APIConstants.UPDATE_CONFIG_METER : APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
//       // const method = isUpdate ? 'POST' : 'POST';

//       // const response = await makeRequest({
//       //   type: method,
//       //   url: url,
//       //   body: apiData,
//       // });
      
//             console.log(response.message)
//       handleNotification(response.message);
//       handleClear();
//       onClose();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const modeselect = useSelector((state) => state.darkMode);
//   const { isdarkMode } = modeselect;

//   return (
//     <Form
//       form={form}
//       onFinish={handleAddFormSubmit}
//       name="add-group-form"
//       className="font-bold w-[600px]"
//       layout="vertical"
//       onValuesChange={handleAddFormChange}
//     >
//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="IEXGDAM" name="iexgdam" rules={[{ required: true, message: "Please enter IEXGDAM" }]}>
//             <InputNumber  className="group-input w-full"  />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="IEXDAM And RTM" name="iexdamAndRTM" rules={[{ required: true, message: "Please enter IEXDAMAndRTM" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Wind" name="wind" rules={[{ required: true, message: "Please enter Wind" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="Solar" name="solar" rules={[{ required: true, message: "Please enter Solar" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Sand Unit One" name="sandUnitOne" rules={[{ required: true, message: "Please enter SandUnitOne" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="Sand Unit Two" name="sandUnitTwo" rules={[{ required: true, message: "Please enter SandUnitTwo" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Investment" name="investment" rules={[{ required: true, message: "Please enter Investment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="SKO Sand" name="skoSand" rules={[{ required: true, message: "Please enter SKOSand" }]}>
//             <InputNumber  className="group-input  w-full " />
//          </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="SKO Investment" name="skoInvestment" rules={[{ required: true, message: "Please enter SKOInvestment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="HSD Sand" name="hsdSand" rules={[{ required: true, message: "Please enter HSDSand" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="HSD Investment" name="hsdInvestment" rules={[{ required: true, message: "Please enter HSDInvestment" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//         <Col span={12}>
//           <Form.Item label="LPG Sand" name="lpgSand" rules={[{ required: true, message: "Please enter LPGSand" }]}>
//             <InputNumber  className="group-input w-full" />
//           </Form.Item>
//         </Col>
//       </Row>

//       {/* Created On as DateTime Picker */}
//       <Row gutter={16}>
//         <Col span={12}>
//           <Form.Item label="Created On" name="createdOn" rules={[{ required: true, message: "Please select Created On date & time" }]}>
//             <DatePicker
//               className="w-full group-input "
//               format="YYYY-MM-DD HH:mm:ss"
//               showTime // Enables Time Picker
//             />
//           </Form.Item>
//         </Col>
//       </Row>

//       <Form.Item className="flex justify-end">
//         <Button htmlType="submit" className="blue-btn mr-2">Save</Button>
//         <Button className="blue-btn" onClick={handleClear}>Clear</Button>
//       </Form.Item>
//     </Form>
//   );
// };
 
const EmissionFactorPopupContent = ({ onClose, isAdd, form, selectedRow, isUpdate,refetch,setRefetch }) => {
  const [data, setData] = useState([]);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const [isPanel1Complete, setIsPanel1Complete] = useState(false);
  const [isPanel2Complete, setIsPanel2Complete] = useState(false);
  const [isPanel3Complete, setIsPanel3Complete] = useState(false);
  const [isPanel4Complete, setIsPanel4Complete] = useState(false);
  const [isPanel5Complete, setIsPanel5Complete] = useState(false);
  const [isPanel6Complete, setIsPanel6Complete] = useState(false);
  const [showMsg1,setShowMsg1]= useState(false)
  const [showMsg2,setShowMsg2]= useState(false)
  const [showMsg3,setShowMsg3]= useState(false)
  const [showMsg4,setShowMsg4]= useState(false)
  const [showMsg5,setShowMsg5]= useState(false)
  const [showMsg6,setShowMsg6]= useState(false)
  
  const handleClear = () => {
    form.resetFields();
    setShowMsg1(false)
    setShowMsg2(false)
    setShowMsg3(false)
    setShowMsg4(false)
    setShowMsg5(false)
    setShowMsg6(false)
    setIsPanel1Complete(false)
    setIsPanel2Complete(false)
    setIsPanel3Complete(false)
    setIsPanel4Complete(false)
    setIsPanel5Complete(false)
    setIsPanel6Complete(false)
  };

  const handleNotification = (msg) => {
    notification.open({ message: `${msg}` });
  };

  useEffect(() => {
    if (isAdd && !selectedRow) {
      form.resetFields();
    }
    if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow);
    } else {
      form.resetFields();
    }
  }, [isAdd, isUpdate, selectedRow, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    setData({
      ...allValues,
      createdOn: allValues.createdOn ? allValues.createdOn.toISOString() : null,
    });
    // setShowMsg6(true)
  };

  const handleAddFormSubmit = async () => {
    setShowMsg6(true)
    try {
      const url = APIConstants.INSERT_GET_EMISSION_FACTOR_MANUAL_ENTRY;
      const response = await makeRequest({
        type: "POST",
        url: url,
        body: data,
      });
      handleNotification(response.message);
      handleClear();
      setRefetch(!refetch)
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const { Panel } = Collapse;
  const [activeKey, setActiveKey] = useState(['1']);

  const handleCollapseChange = (key) => {

    setActiveKey(key ? [key] : []);
  if (key==2) {
      setShowMsg1(true)
  }else if (key==3) {
    setShowMsg2(true)
  }else if (key==4) {
    setShowMsg3(true)
  }else if (key==5) {
    setShowMsg4(true)
  }else if (key==6) {
    setShowMsg5(true)
  }
}

  // const [isPanel1Complete, setIsPanel1Complete] = useState(false);
  const validatePanel = (panelFields, allValues) => {
    return panelFields.every(field => allValues[field] !== undefined && allValues[field] !== null && allValues[field] !== "");
  };
  
  const checkPanel1Completion = (_, allValues, setIsPanel1Complete) => {
    const panel1Fields = ["electricalEnergy", "hsd", "sko", "lpg"];
    setIsPanel1Complete(validatePanel(panel1Fields, allValues));
    // setShowMsg1(true)
  };
  
  const checkPanel2Completion = (_, allValues, setIsPanel2Complete) => {
    const panel2Fields = ["smmlPlant", "sandUnit1", "sandUnit2", "investment"];
    setIsPanel2Complete(validatePanel(panel2Fields, allValues));
    // setShowMsg1(true)
  };
  
  const checkPanel3Completion = (_, allValues, setIsPanel3Complete) => {
    const panel3Fields = ["sandFoundry1Melting", "sandFoundry1AirCompressor", "sandFoundry1ElectricalHTF", "sandFoundry1Thermal", "sandFoundry1Fettling", "sandFoundry1Others"];
    setIsPanel3Complete(validatePanel(panel3Fields, allValues));
    // setShowMsg2(true)
  };
  const checkPanel4Completion = (_, allValues, setIsPanel3Complete) => {
    const panel4Fields = ["sandFoundry2Melting", "sandFoundry2AirCompressor", "sandFoundry2Fettling1Stage", "sandFoundry2ShedCFettling", "sandFoundry2Pump", "sandFoundry2Other"];
    setIsPanel4Complete(validatePanel(panel4Fields, allValues));
    // setShowMsg3(true)
  };
  const checkPanel5Completion = (_, allValues, setIsPanel3Complete) => {
    const panel5Fields = ["investmentMelting", "investmentWaxAndShelling", "investmentACPlant", "investmentHTFurnace", "investmentMeltingPumps", "investmentOther"];
    setIsPanel5Complete(validatePanel(panel5Fields, allValues));
    // setShowMsg4(true)
  };
  const checkPanel6Completion = (_, allValues, setIsPanel3Complete) => {
    const panel6Fields = ["createdOn"];
    setIsPanel6Complete(validatePanel(panel6Fields, allValues));
    // setShowMsg5(true)
  };

  const color = useSelector((state) => state.ThemeChange);
  console.log(color)
  useEffect(() => { 
    document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);


  return (

    <Form
  form={form}
  onFinish={handleAddFormSubmit}
  name="add-group-form"
  className="font-bold w-[100%]"
  layout="vertical"
  onValuesChange={(_, allValues) => {
    checkPanel1Completion(_, allValues, setIsPanel1Complete);
    checkPanel2Completion(_, allValues, setIsPanel2Complete);
    checkPanel3Completion(_, allValues, setIsPanel3Complete);
    checkPanel4Completion(_, allValues, setIsPanel4Complete);
    checkPanel5Completion(_, allValues, setIsPanel5Complete);
    checkPanel6Completion(_, allValues, setIsPanel6Complete);
    handleAddFormChange(_, allValues);
  }}
>
  <Collapse activeKey={activeKey} onChange={handleCollapseChange} accordion 
  className={` ${ isdarkMode ? "dark-modal-collapse":''} h-[60vh] overflow-auto `}  >
    <Panel  key="1"  header={
        <div className="flex items-center">
          Emission Factors
          {
            showMsg1&&<>
          {isPanel1Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
      <Row gutter={8} className="">
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Electrical Energy" name="electricalEnergy"><InputNumber  className={`w-full 
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600" : 
                ""
              }`} /></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="HSD" name="hsd"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="SKO" name="sko"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="LPG" name="lpg"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
    </Panel>

    <Panel  key="2" header={
        <div className="flex items-center">
          SEC Targets Summary
          {
            showMsg2&&<>
          {isPanel2Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="SMML Plant" name="smmlPlant"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Sand Unit-1" name="sandUnit1"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Sand Unit-2" name="sandUnit2"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Investment" name="investment"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
    </Panel>

    <Panel   key="3" header={
        <div className="flex items-center">
          Sand Foundry-1
          {
            showMsg3&&<>
          {isPanel3Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }>
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Melting" name="sandFoundry1Melting"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Air Compressor" name="sandFoundry1AirCompressor"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Electric HTF" name="sandFoundry1ElectricalHTF"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Thermal" name="sandFoundry1Thermal"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Fettling" name="sandFoundry1Fettling"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Others" name="sandFoundry1Others"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
    </Panel>

    <Panel key="4" header={
        <div className="flex items-center">
          Sand Foundry-2
          {
            showMsg4&&<>
          {isPanel4Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      } >
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Melting" name="sandFoundry2Melting"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Air Compressor" name="sandFoundry2AirCompressor"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="1st Stage Fettling" name="sandFoundry2Fettling1Stage"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Shed-C Fettling" name="sandFoundry2ShedCFettling"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Pump" name="sandFoundry2Pump"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Other" name="sandFoundry2Other"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                ""
              }`}/></Form.Item></Col>
      </Row>
    </Panel>

    <Panel key="5"  header={
        <div className="flex items-center">
          Investment
          {
            showMsg5&&<>
          {isPanel5Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      } >
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Melting" name="investmentMelting"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Wax & Shelling" name="investmentWaxAndShelling"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="AC Plant" name="investmentACPlant"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="HT Furnace" name="investmentHTFurnace"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
      <Row gutter={8}>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Melting Pumps" name="investmentMeltingPumps"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
        <Col span={6}><Form.Item rules={[{ required: true }]} label="Other" name="investmentOther"><InputNumber className={`w-full transition-colors duration-300
              ${isdarkMode ? 
                "bg-gray-800 custom-input-number border-gray-600 focus:bg-gray-700 hover:bg-gray-700" : 
                "bg-white text-black border-gray-300 focus:bg-gray-100 hover:bg-gray-100"
              }`}/></Form.Item></Col>
      </Row>
    </Panel>
        <Panel key="6"  header={
        <div className="flex items-center">
          Created On
          {
            showMsg6&&<>
          {isPanel6Complete ? <span>
            ✅
          </span>:<span className="text-red-600 ml-3">
          Please fill all fields</span>
            }
            </>
          }
        </div>
      }  >
            <Row gutter={16}>
              <Col span={6}><Form.Item rules={[{ required: true }]} label="Created On" name="createdOn" ><DatePicker  className={`  ${isdarkMode ? "datebackground dateplaceholder" : "whitemode"} w-80 `}
              dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"} format="YYYY-MM-DD HH:mm:ss" showTime
              popupClassName="custom-picker" /></Form.Item></Col>
            </Row>
        </Panel>
  </Collapse>

  <Form.Item className="flex justify-end mt-5">
    <Button htmlType="submit" className="mr-2">Save</Button>
    <Button className="" type="primary" onClick={handleClear}>Clear</Button>
  </Form.Item>
  <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style> 
</Form>


  );
};
 

const EmissionFactorPopup = ({ 
  isAdd,
  setIsAdd,  
  isUpdate, 
  selectedRow,
  setIsUpdate,
  title,
  refetch,
  setRefetch
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_EMISSION_FACTOR}/emission-factor-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);
    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_EMISSION_FACTOR}`);
    form.resetFields();
  };

  return (
    <>
      <PopupUI
        popupContent={
          <EmissionFactorPopupContent
          onClose={handleClose}
          isAdd={isAdd}
          isUpdate={isUpdate}
          selectedRow={selectedRow}
          form={form}
          title={title}
          refetch={refetch}
          setRefetch={setRefetch}
          />
        }
        isAdd={isAdd}
        setIsUpdate={setIsUpdate}
        handleClose={handleClose}
        isOpen={isAdd || isUpdate}
        title={title}
      />
    </>
  );
};

export default EmissionFactorPopup;
